"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserVaults = fetchUserVaults;
const index_js_1 = require("../../index.js");
const maps_js_1 = require("../../common/maps.js");
const getReceipts_js_1 = require("./getReceipts.js");
async function fetchUserVaults(address) {
    const vaultsArr = [];
    await (0, index_js_1.getMultiReceipts)(address);
    await Promise.all(Object.keys(maps_js_1.poolInfo).map(async (pool) => {
        const receipt = await (0, getReceipts_js_1.getReceipts)(pool, address, false);
        if (receipt.length > 0) {
            const name = receipt[0].content.fields.name;
            let res = undefined;
            if (maps_js_1.poolInfo[pool].parentProtocolName === "ALPHAFI" ||
                maps_js_1.poolInfo[pool].parentProtocolName === "NAVI" ||
                maps_js_1.poolInfo[pool].parentProtocolName === "BUCKET" ||
                maps_js_1.poolInfo[pool].parentProtocolName === "ALPHALEND") {
                const coin = maps_js_1.singleAssetPoolCoinMap[pool].coin;
                res = {
                    poolId: maps_js_1.poolInfo[pool].poolId,
                    poolName: pool,
                    receiptName: name,
                    receiptType: receipt[0].content.type,
                    coinName: coin,
                    coinType: index_js_1.coinsList[coin].type,
                };
            }
            else if (maps_js_1.poolInfo[pool].parentProtocolName === "CETUS" ||
                maps_js_1.poolInfo[pool].parentProtocolName === "BLUEFIN") {
                const coinA = maps_js_1.doubleAssetPoolCoinMap[pool].coin1;
                const coinB = maps_js_1.doubleAssetPoolCoinMap[pool].coin2;
                res = {
                    poolId: maps_js_1.poolInfo[pool].poolId,
                    poolName: pool,
                    receiptName: name,
                    receiptType: receipt[0].content.type,
                    coinNameA: coinA,
                    coinTypeA: index_js_1.coinsList[coinA].type,
                    coinNameB: coinB,
                    coinTypeB: index_js_1.coinsList[coinB].type,
                };
            }
            if (res)
                vaultsArr.push(res);
        }
    }));
    return vaultsArr;
}
//# sourceMappingURL=fetchUserVaults.js.map